import * as React from 'react';
import { Basic } from '../../components/Basic';
import { Call } from '../Call/Call';
import { BasicCallbackButton } from '../CallbackButton';
import { FlatViewOrderPopupContainer } from '../FlatViewOrderPopup';
import { LabelsContainer } from '../Labels';
import { NewbuildingNameContainer } from '../NewbuildingName';
import { PriceContainer } from '../Price';

export function BasicContainer() {
  return (
    <Basic
      name={<NewbuildingNameContainer />}
      price={<PriceContainer />}
      callback={<BasicCallbackButton />}
      call={<Call />}
      flatViewOrder={<FlatViewOrderPopupContainer />}
      labels={<LabelsContainer />}
    />
  );
}
